

export const ADVANCED_NOTES_TYPE = {
    FOLDER: 0,
    IMAGE: 1,
    VIDEO: 2,
    PDF: 3,
    FILE: 4,
    NOTE: 5
}